<ng-container *transloco="let t">
  @if (state()?.config) {
    <cw-sidebar
      [open]="state()!.opened"
      [showCloseButton]="true"
      [heading]="state()!.config!.heading || ''"
      [secondaryButtonLabel]="t(state()!.config!.secondaryButtonLabel || '')"
      [actionButtonLabel]="t(state()!.config!.actionButtonLabel || '')"
      [closeOnOutsideClick]="state()!.config!.closeOnOutsideClick || false"
      (sidebarClose)="componentInstance()!.onSidebarClose()"
      (sidebarActionClick)="componentInstance()!.onSidebarActionClick()">
      <ng-template [cdkPortalOutlet]="state()!.portal"></ng-template>
    </cw-sidebar>
  }
</ng-container>
